import { use } from 'react';

import { CustomThemeContext } from './theme-context';

export const useTheme = () => {
  const { theme, mode, toggleMode } = use(CustomThemeContext);

  return { ...theme, mode, toggleMode };
};
